import { Terminal, ArrowUp } from "lucide-react";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-[#E6E2DC] bg-ink">
      <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12">
        <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center border border-neon-teal/60 bg-[#581820]/[0.05] text-neon-teal">
                <Terminal size={20} strokeWidth={2.4} />
              </span>
              <span className="font-display text-2xl font-bold uppercase tracking-tight text-[#141210]">
                The Geeks <span className="text-neon-teal">Labs</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#6B655F]">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="flex flex-col gap-2 text-sm text-[#6B655F]">
            <span className="mb-1 text-[10px] font-bold uppercase tracking-[0.25em] text-[#8A837B]">
              {t("footer.reachUs")}
            </span>
            <a href="mailto:info@thegeekslabs.com" className="transition-colors duration-300 hover:text-neon-teal" data-testid="footer-email">
              info@thegeekslabs.com
            </a>
            <a href="tel:+17325244574" className="transition-colors duration-300 hover:text-neon-teal" data-testid="footer-phone">
              +1 732 524 4574
            </a>
            <span className="text-[#6B655F]" data-testid="footer-locations">
              Tema, Ghana · Abidjan, Côte d'Ivoire
            </span>
          </div>
        </div>

        <div className="mt-16 flex items-center justify-between border-t border-[#E6E2DC] pt-8">
          <p className="text-xs text-[#8A837B]" data-testid="footer-copyright">
            © {new Date().getFullYear()} The Geeks Labs — {t("footer.rights")}
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] text-[#6B655F] transition-colors duration-300 hover:text-neon-teal"
          >
            {t("footer.top")} <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
